import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var ChatIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,13l-5,0c2.502,0.023 5,3.333 5,3.333l0,-3.333Zm3,-6.75c-0,-1.242 -1.008,-2.25 -2.25,-2.25l-9.5,0c-1.242,0 -2.25,1.008 -2.25,2.25l0,4.5c0,1.242 1.008,2.25 2.25,2.25l9.5,0c1.242,0 2.25,-1.008 2.25,-2.25l-0,-4.5Zm-5,-1.25c0,-0 2.006,0.749 2.673,1.415c0.667,0.667 1.327,2.585 1.327,2.585c0,-0 0.285,-2.206 -0.737,-3.228c-1,-1 -3.263,-0.772 -3.263,-0.772Z"
  }));
});
ChatIcon.displayName = 'ChatIcon';
export default ChatIcon;